import React from "react";
import RiskName from "../riskName/riskName";
import { RisksId } from "../../../../helpers/risk";
import { CalculateStore } from "../../../../stores/calculateStore";
import { inject, observer } from "mobx-react";
import DropDown from "../../../sharedComponents/dropDown/dropDown";
import Header from "../../../sharedComponents/header/header";
import { ReactComponent as NnwIcon } from "../../../../statics/icons/nnw.svg";
import { getNnwNumberOfClientsDropDown, NnwInsuranceSumDropDown } from "../../../../helpers/nnw";
import InsuranceSumDropDown from "../insuranceSumDropDown/InsuranceSumDropDown";
import Notification from "../../../sharedComponents/notification/notification";
import { CountId } from "../../../../helpers/dropDown";
import { ProposalStore } from "../../../../stores/proposalStore";
import { displayAdditionalRiskForm, RisksNetworkTypes } from "../../../../helpers/risksNetwork";
import { PolicyStore } from "../../../../stores/policyStore";

interface NnwProps {
  calculateStore?: CalculateStore;
  proposalStore?: ProposalStore;
  policyStore?: PolicyStore;
}

@inject("calculateStore", "proposalStore", "policyStore")
@observer
export default class Nnw extends React.Component<NnwProps> {
  constructor(props: NnwProps) {
    super(props);
    this.props.proposalStore!.nnw.setNnwNumberOfClients(this.props.calculateStore!.additionalInsurances.nnwType.numberOfClients);
  }
  public render() {
    const calculateStore = this.props.calculateStore!;
    const shouldRenderNnwWithoutProperty = calculateStore.nnw;
    const nnwDisabled = calculateStore.additionalInsurances.nnwType.risksNetworkValue === RisksNetworkTypes.notAvailable;

    return (
      <div className="section nnw">
        <div className={`nnw-header ${nnwDisabled ? "disabled" : ""}`}>
          <NnwIcon className="icon-svg-color" />
          <Header type="small" mainHeader="Ubezpieczenie NNW" />
        </div>
        <div className="nnw-content">
          {shouldRenderNnwWithoutProperty && this.renderNnwWithoutProperty()}
          {this.renderNnwType()}
          {this.renderNnwSenior()}
          {this.renderNnwHeartAttackAndStroke()}
          {!!calculateStore.nnwClientsSubtractionCount.errorMessage &&
            <Notification type="error" message={calculateStore.nnwClientsSubtractionCount.errorMessage} />}
        </div>
      </div>
    );
  }

  renderNnwWithoutProperty() {
    const store = this.props.calculateStore!;

    return (
      <div className="nnw-without-property">
        <RiskName riskId={RisksId.nnwWithoutProperty}
          displayIcon={false}
          required={true}
          checkboxOnChange={(event) => {
            store.setAdditionalInsuranceFieldChecked(RisksId.nnwWithoutProperty, event.target.checked);
            store.setPropertyInsurance(!event.target.checked);
            this.validate();
          }}
        />
      </div>
    );
  }

  renderNnwType() {
    const calculateStore = this.props.calculateStore!;
    const proposalStore = this.props.proposalStore!;
    const nnwType = calculateStore.additionalInsurances.nnwType;
    const displayForm = displayAdditionalRiskForm(calculateStore.additionalInsurances.nnwType);
    const nnwNumberOfClientsDropDown = getNnwNumberOfClientsDropDown("insureds", this.props.policyStore!.isPolicyRenewal);

    return (
      <div className="nnw-type">
        <RiskName riskId={RisksId.nnwType}
          displayIcon={false}
          checkboxOnChange={(event) => {
            calculateStore.setAdditionalInsuranceFieldChecked(RisksId.nnwType, event.target.checked);
            proposalStore.nnw.setNnwNumberOfClients(calculateStore.additionalInsurances.nnwType.numberOfClients);

            if (event.target.checked === false) {
              calculateStore.setAdditionalInsuranceFieldChecked(RisksId.nnwSenior, false);
              calculateStore.setAdditionalInsuranceFieldChecked(RisksId.nnwHeartAttackAndStroke, false);
              calculateStore.setNnwNumberOfSeniors(CountId.zero);
              calculateStore.setNnwNumberOfHeartAttackAndStrokeInsureds(CountId.zero);
              this.validate();
            }
          }}
        />

        {displayForm && (
          <div className="nnw-type-value">
            <DropDown value={nnwType.numberOfClients}
              items={nnwNumberOfClientsDropDown.dropDown}
              onChange={(value) => {
                calculateStore.setNnwNumberOfClients(value);
                proposalStore.nnw.setNnwNumberOfClients(value);
                this.validate();
              }}
              topLabel={nnwNumberOfClientsDropDown.label}
            />
            <InsuranceSumDropDown riskId={RisksId.nnwType}
              value={nnwType.insuranceSum}
              items={NnwInsuranceSumDropDown}
            />
          </div>
        )}
      </div>
    );
  }

  renderNnwSenior() {
    const calculateStore = this.props.calculateStore!;
    const nnwSenior = calculateStore.additionalInsurances.nnwSenior;
    const nnwNumberOfClientsDropDown = getNnwNumberOfClientsDropDown("seniors", this.props.policyStore!.isPolicyRenewal);

    return (
      <div className="nnw-senior">
        <RiskName riskId={RisksId.nnwSenior}
          displayIcon={false}
          available={this.isNnwExtensionsAvailable()}
          infoMessage={this.nnwTypeNotification()}
          checkboxOnChange={(event) => {
            calculateStore.setAdditionalInsuranceFieldChecked(RisksId.nnwSenior, event.target.checked);
            if (!nnwSenior.checked) {
              calculateStore.setNnwNumberOfSeniors(CountId.zero);
            } else {
              calculateStore.setNnwNumberOfSeniors(CountId.one);
            }
            this.validate();
          }}
        />

        {nnwSenior.checked && (
          <div className="nnw-senior-value">
            <DropDown value={nnwSenior.nnwNumberOfSeniors}
              items={nnwNumberOfClientsDropDown.dropDown}
              onChange={(value) => {
                calculateStore.setNnwNumberOfSeniors(value);
                this.validate();
              }}
              topLabel={nnwNumberOfClientsDropDown.label}
            />
          </div>
        )}
      </div>
    );
  }

  renderNnwHeartAttackAndStroke() {
    const calculateStore = this.props.calculateStore!;
    const nnwHeartAttackAndStroke = calculateStore.additionalInsurances.nnwHeartAttackAndStroke;
    const nnwNumberOfClientsDropDown = getNnwNumberOfClientsDropDown("heartAttackAndStrokeInsureds", this.props.policyStore!.isPolicyRenewal);

    return (
      <div className="nnw-heart-attack-and-stroke">
        <RiskName riskId={RisksId.nnwHeartAttackAndStroke}
          displayIcon={false}
          available={this.isNnwExtensionsAvailable()}
          infoMessage={this.nnwTypeNotification()}
          checkboxOnChange={(event) => {
            calculateStore.setAdditionalInsuranceFieldChecked(RisksId.nnwHeartAttackAndStroke, event.target.checked);
            if (!nnwHeartAttackAndStroke.checked) {
              calculateStore.setNnwNumberOfHeartAttackAndStrokeInsureds(CountId.zero);
            } else {
              calculateStore.setNnwNumberOfHeartAttackAndStrokeInsureds(CountId.one);
            }
            this.validate();
          }}
        />

        {nnwHeartAttackAndStroke.checked && (
          <div className="nnw-heart-attack-and-stroke-value">
            <DropDown value={nnwHeartAttackAndStroke.numberOfClients}
              items={nnwNumberOfClientsDropDown.dropDown}
              onChange={(value) => {
                calculateStore.setNnwNumberOfHeartAttackAndStrokeInsureds(value);
                this.validate();
              }}
              topLabel={nnwNumberOfClientsDropDown.label}
            />
          </div>
        )}
      </div>
    );
  }

  private validate() {
    this.props.calculateStore!.nnwClientsSubtractionCount.validateNnwClientSubstraction();
  }

  private nnwTypeNotification() {
    const nnwType = this.props.calculateStore!.additionalInsurances.nnwType;
    const nnwTypeChecked = nnwType.checked;
    const nnwTypeRequired = nnwType.risksNetworkValue === RisksNetworkTypes.required;
    const nnwTypeAvailable = nnwType.risksNetworkValue === RisksNetworkTypes.available || nnwType.risksNetworkValue === undefined;

    if (!nnwTypeChecked && !nnwTypeRequired && nnwTypeAvailable) {
      return "Dostępne po wybraniu NNW";
    }
    return "";
  }

  private isNnwExtensionsAvailable() {
    const calculateStore = this.props.calculateStore!;
    const nnwType = calculateStore.additionalInsurances.nnwType;

    return (nnwType.checked && nnwType.risksNetworkValue === RisksNetworkTypes.available) ||
      nnwType.risksNetworkValue === RisksNetworkTypes.required;
  }
}
